module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_26.4c0f45d6.jpg";